import update from 'immutability-helper';

import { RootActionTypes } from '../../../stores/types';
import { PriceBookComponentState } from '../types/types';
import ActionTypes from '../types/action-types';

const initialState: PriceBookComponentState = {
  options: [],
};

export default function priceBooksReducer(
  state = initialState,
  action: RootActionTypes,
): PriceBookComponentState {
  switch (action.type) {
    case ActionTypes.FETCH_PRICE_BOOK_EXPORT_TYPES_REQUEST:
      return update(state, {
        options: {
        },
        error: {
        },
      });
    case ActionTypes.FETCH_PRICE_BOOK_EXPORT_TYPES_SUCCESS:
      return update(state, {
        options: {
        },
        error: {
        },
      });
    case ActionTypes.FETCH_PRICE_BOOK_EXPORT_TYPES_FAILURE:
      return update(state, {
        options: {
        },
        error: {
        },
      });
    default:
      return state;
  }
}
